var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoading1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9799 2.125C12.4877 2.125 12.8994 2.53669 12.8994 3.04454V5.34339C12.8994 5.85124 12.4877 6.26293 11.9799 6.26293C11.472 6.26293 11.0603 5.85124 11.0603 5.34339V3.04454C11.0603 2.53669 11.472 2.125 11.9799 2.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9799 16.6078C12.4877 16.6078 12.8994 17.0195 12.8994 17.5273V21.2055C12.8994 21.7133 12.4877 22.125 11.9799 22.125C11.472 22.125 11.0603 21.7133 11.0603 21.2055V17.5273C11.0603 17.0195 11.472 16.6078 11.9799 16.6078Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09482 12.0101C2.09482 11.5022 2.50651 11.0905 3.01436 11.0905H6.23275C6.7406 11.0905 7.15229 11.5022 7.15229 12.0101C7.15229 12.5179 6.7406 12.9296 6.23275 12.9296H3.01436C2.50651 12.9296 2.09482 12.5179 2.09482 12.0101Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1868 12.0101C18.1868 11.5022 18.5985 11.0905 19.1063 11.0905H20.4856C20.9935 11.0905 21.4052 11.5022 21.4052 12.0101C21.4052 12.5179 20.9935 12.9296 20.4856 12.9296H19.1063C18.5985 12.9296 18.1868 12.5179 18.1868 12.0101Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.617 16.6472C16.9761 16.2881 17.5583 16.2881 17.9174 16.6472L18.5677 17.2974C18.9268 17.6565 18.9268 18.2387 18.5677 18.5978C18.2086 18.9569 17.6263 18.9569 17.2672 18.5978L16.617 17.9476C16.2579 17.5885 16.2579 17.0063 16.617 16.6472Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7581 5.30539C19.1172 5.6645 19.1172 6.24672 18.7581 6.60582L17.4577 7.90625C17.0986 8.26535 16.5164 8.26535 16.1572 7.90625C15.7981 7.54714 15.7981 6.96492 16.1572 6.60582L17.4577 5.30539C17.8168 4.94629 18.399 4.94629 18.7581 5.30539Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72204 15.2679C9.08115 15.627 9.08115 16.2092 8.72204 16.5683L6.12119 19.1692C5.76209 19.5283 5.17987 19.5283 4.82076 19.1692C4.46166 18.8101 4.46166 18.2278 4.82076 17.8687L7.42162 15.2679C7.78072 14.9088 8.36294 14.9088 8.72204 15.2679Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01121 5.11495C5.37031 4.75585 5.95253 4.75585 6.31163 5.11495L8.26227 7.06559C8.62138 7.42469 8.62138 8.00691 8.26227 8.36602C7.90317 8.72512 7.32095 8.72512 6.96185 8.36602L5.01121 6.41538C4.6521 6.05628 4.6521 5.47405 5.01121 5.11495Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoading1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Loading1.af2e5c6501e8da0207d5601858eefb39.svg";